// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popup-btn a {
  top: 200px;
  position: fixed;
  right: -50px;
  z-index: 1000;
  transform: rotate(-90deg);
  background-color: #db233a;
  padding: 15px 30px 15px 20px;
  /* height: 0px;
    width: 131px; */
  color: #fff;
  text-decoration: none;
}

.popup-btnmob a {
  top: 300px;
  position: fixed;
  right: -80px;
  z-index: 1000;
  transform: rotate(0.5deg);
  background-color: #db233a;
  padding: 6px 8px 35px;
  height: 0px;
  width: 130px;
  color: #fff;
  text-decoration: none;
}

.popup-btn a:hover {
  text-decoration: none;
  color: #fff;
}

.card {
  position: relative;
  padding: 10px 20px;
}

.cardtitle {
  font-family: saira;
  font-size: 20px;
  font-weight: 500;
}

.card-body {
  flex: 1 1 auto;
  padding: 0rem 2rem;
}

.feedbacknavtabs {
  border-bottom: 4px solid #eee;
  width: 75px;
}

.feedbacknavtabs.active {
  color: #e31837;
  border-bottom: 4px solid #e31837;
  width: 75px;
  font-weight: 600;
  font-size: 14px;
  font-family: Saira;
}

.emojip {
  margin: 10px 3px;
  font-size: 16px;
  font-weight: 400;
}

.cardDiv {
  width: 30%;
  position: fixed;
  right: 0px;
  box-shadow: 1px 1px 3px;
  z-index: 999;
}

@media screen and (max-width: 700px) {
  .cardDiv {
    width: 100%;
    margin-top: 50%;
    position: fixed;
    right: 0px;
    box-shadow: 1px 1px 3px;
    z-index: 999;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/feedbackNote/Feedback.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,eAAe;EACf,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,4BAA4B;EAC5B;mBACiB;EACjB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,UAAU;EACV,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE;IACE,WAAW;IACX,eAAe;IACf,eAAe;IACf,UAAU;IACV,uBAAuB;IACvB,YAAY;EACd;AACF","sourcesContent":[".popup-btn a {\n  top: 200px;\n  position: fixed;\n  right: -50px;\n  z-index: 1000;\n  transform: rotate(-90deg);\n  background-color: #db233a;\n  padding: 15px 30px 15px 20px;\n  /* height: 0px;\n    width: 131px; */\n  color: #fff;\n  text-decoration: none;\n}\n\n.popup-btnmob a {\n  top: 300px;\n  position: fixed;\n  right: -80px;\n  z-index: 1000;\n  transform: rotate(0.5deg);\n  background-color: #db233a;\n  padding: 6px 8px 35px;\n  height: 0px;\n  width: 130px;\n  color: #fff;\n  text-decoration: none;\n}\n\n.popup-btn a:hover {\n  text-decoration: none;\n  color: #fff;\n}\n\n.card {\n  position: relative;\n  padding: 10px 20px;\n}\n\n.cardtitle {\n  font-family: saira;\n  font-size: 20px;\n  font-weight: 500;\n}\n\n.card-body {\n  flex: 1 1 auto;\n  padding: 0rem 2rem;\n}\n\n.feedbacknavtabs {\n  border-bottom: 4px solid #eee;\n  width: 75px;\n}\n\n.feedbacknavtabs.active {\n  color: #e31837;\n  border-bottom: 4px solid #e31837;\n  width: 75px;\n  font-weight: 600;\n  font-size: 14px;\n  font-family: Saira;\n}\n\n.emojip {\n  margin: 10px 3px;\n  font-size: 16px;\n  font-weight: 400;\n}\n\n.cardDiv {\n  width: 30%;\n  position: fixed;\n  right: 0px;\n  box-shadow: 1px 1px 3px;\n  z-index: 999;\n}\n\n@media screen and (max-width: 700px) {\n  .cardDiv {\n    width: 100%;\n    margin-top: 50%;\n    position: fixed;\n    right: 0px;\n    box-shadow: 1px 1px 3px;\n    z-index: 999;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
